import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'


const initialState = {
    loadJobListStatus: 'idle',
    loadJobListError: undefined as any,
    loadJobListLastParams: undefined,
    createJobStatus: 'idle',
    createJobError: undefined as any,
    updateJobStatus: 'idle',
    updateJobError: undefined as any,
    deleteJobStatus: 'idle',
    deleteJobError: undefined as any,

    protokollList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
}

export const loadJobList = createAsyncThunk('jobSlice/loadJobList', async ({ forceReload=false }: any, { rejectWithValue, getState }: any) => {
    const { loadJobListLastParams } = getState().jobSlice

    const url = `/api/ixweb/protokoll/`
    let _allParams: any = new URLSearchParams(url.split('?')[1])
    _allParams.sort()
    _allParams = _allParams.toString()

    if (_allParams === loadJobListLastParams && !forceReload) {
        return
    }

    const res = await client.get(url)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { data: res.data.data, params: _allParams }
        }
    } else {  // backend response
        return { data: res.data, params: _allParams }
    }
})
export const createJob = createAsyncThunk('jobSlice/createJob', async (protokoll: any, { rejectWithValue }: any) => {

    const url = `/api/ixweb/protokoll/`

    const res = await client.post(url, prepareData(protokoll))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...protokoll, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const updateJob = createAsyncThunk('jobSlice/updateJob', async (protokoll: any, { rejectWithValue }: any) => {

    const url = `/api/ixweb/protokoll/${protokoll.HDR_ID}/`

    const res = await client.put(url, prepareData(protokoll))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return protokoll
        }
    } else {  // backend response
        return res.data
    }
})
export const deleteJob = createAsyncThunk('jobSlice/deleteJob', async (id: any, { rejectWithValue }: any) => {

    const url = `/api/ixweb/protokoll/${id}/`

    const res = await client.delete(url)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return id
        }
    } else {  // backend response
        return id
    }
})

const ProtokollSlice = createSlice({
    name: 'jobSlice',
    initialState,
    reducers: {
        resetloadJobListError: (state) => {
            state.loadJobListError = undefined
        },
        resetcreateJobError: (state) => {
            state.createJobError = undefined
        },
        resetupdateJobError: (state) => {
            state.updateJobError = undefined
        },
        resetdeleteJobError: (state) => {
            state.deleteJobError = undefined
        },
        removeFromProtokollListById: (state, action) => {
            state.protokollList = state.protokollList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
    },
    extraReducers: builder => {
        builder.addCase(loadJobList.pending, (state) => {
            state.loadJobListStatus = 'pending'
            state.loadJobListError = undefined
        })
        builder.addCase(loadJobList.fulfilled, (state, action) => {
            state.loadJobListStatus = 'idle'

            if (!action.payload) { return }

            state.loadJobListLastParams = action.payload.params

            state.protokollList = action.payload.data
        })
        builder.addCase(loadJobList.rejected, (state, action) => {
            state.loadJobListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadJobListError = action.error.message
            } else {
                state.loadJobListError = action.payload
            }
        })

        builder.addCase(createJob.pending, (state) => {
            state.createJobStatus = 'pending'
            state.createJobError = undefined
        })
        builder.addCase(createJob.fulfilled, (state, action) => {
            state.createJobStatus = 'idle'


            state.protokollList = [...state.protokollList, action.payload]
        })
        builder.addCase(createJob.rejected, (state, action) => {
            state.createJobStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createJobError = action.error.message
            } else {
                state.createJobError = action.payload
            }
        })

        builder.addCase(updateJob.pending, (state) => {
            state.updateJobStatus = 'pending'
            state.updateJobError = undefined
        })
        builder.addCase(updateJob.fulfilled, (state, action) => {
            state.updateJobStatus = 'idle'


            const i = state.protokollList.findIndex((x: any) => x.HDR_ID === action.payload.HDR_ID)
            if (i === -1) { state.protokollList.push(action.payload) }
            else { state.protokollList[i] = { ...state.protokollList[i], ...action.payload } }
        })
        builder.addCase(updateJob.rejected, (state, action) => {
            state.updateJobStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateJobError = action.error.message
            } else {
                state.updateJobError = action.payload
            }
        })

        builder.addCase(deleteJob.pending, (state) => {
            state.deleteJobStatus = 'pending'
            state.deleteJobError = undefined
        })
        builder.addCase(deleteJob.fulfilled, (state, action) => {
            state.deleteJobStatus = 'idle'


            state.protokollList = state.protokollList.filter((x: any) => x.HDR_ID !== action.payload)
        })
        builder.addCase(deleteJob.rejected, (state, action) => {
            state.deleteJobStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteJobError = action.error.message
            } else {
                state.deleteJobError = action.payload
            }
        })

    }
})

export const {
    resetloadJobListError,
    resetcreateJobError,
    resetupdateJobError,
    resetdeleteJobError,
    removeFromProtokollListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
} = ProtokollSlice.actions
export default ProtokollSlice.reducer
